module.exports = __webpack_public_path__ + "static/media/Styles.57ac6d7d.less";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Tasks/Styles.less
// module id = 479
// module chunks = 0